import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is custom software development?",
    answer: `<p>The process of creating bespoke software solutions that exactly match business needs and achieve the highest standards of efficiency and performance is known as custom software development.</p>`,
  },
  {
    question: "Why opt for custom software over off-the-shelf solutions?",
    answer: ` <p>Custom software includes exclusive features customized to accommodate the business's value, proposition, and objectives. It's noteworthy that the custom software development journey extends beyond the development phase, ensuring continuous refinement and adaptation to evolving needs.</p>`,
  },
  {
    question: "Why hire a custom software development company?",
    answer: `<p>Customization is a significant advantage of investing in custom software. A reputable software development company may create software programs that are suited to the needs of your business. They can provide a bespoke software solution that is optimized for your company's specific processes.</p>`,
  },
  {
    question: "What are custom software development services?",
    answer: `<p>Custom software development includes the process of building software applications that would meet the distinct needs of a business organization. Changeable solutions instead of ready-made plates are often designed to solve precise problems.</p>`,
  },
  {
    question: "How long does it take to develop custom software?",
    answer: ` <p>The timeline varies depending on the project's complexity. Typically, it may span from 4 to 9 months, or even extend to a year, to finalize a detailed development process and undergo rigorous testing.</p>`,
  },
  {
    question: "How do you guarantee the security of custom software?",
    answer: ` <p>At TekRevol, we prioritize security at every phase, applying strong measures such as encryption, consistent security audits, and compliance with industry standards to protect sensitive data.</p>`,
  },
  {
    question: "Can custom software be integrated with present systems?",
    answer: `<p>Yes, custom software is designed to effortlessly integrate with your existing systems, guaranteeing a consistent and modernized workflow across your organization.</p>`,
  },
  {
    question: "Does TekRevol offer a free consultation, or quote for Custom Software Development?",
    answer: `<p>Yes, we provide free consultation services. Our expert consultants and IT professionals offer guidance and assist clients without any initial charges help clients with a roadmap on how their project will be designed and how it will perform overall. Reach out to our team today to kickstart your app journey.</p>`,
  },
  {
    question: "What is a custom software development agency?",
    answer: `<p>A custom software development agency is a business that creates software to satisfy the unique requirements of its customers. It means that they can supply products and services that are properly varied to their client's demands, perhaps resulting in cheaper costs and improved quality for them.</p>`
  },
  {
    question:
      "How much does it cost to develop custom software?",
    answer: `<p>Custom software development costs vary widely depending on the features, technologies used, complexity of the project, length of development, and location of the development team. However, the estimated cost of custom software development is:</p>
<div class="table-responsive">
    <table class="table">
        <thead>
            <tr>
                <th scope="col">Project Size</th>
                <th scope="col">Cost</th>
                <th scope="col">Examples</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Small</td>
                <td>$20,000 - $50,000</td>
                <td>Basic apps</td>
            </tr>
            <tr>
                <td>Mid-Level</td>
                <td>$50,000 - $200,000</td>
                <td>eCommerce Apps</td>
            </tr>
            <tr>
                <td>Enterprise Level</td>
                <td>$200,000+</td>
                <td>Complex Apps with latest features</td>
            </tr>
        </tbody>
    </table>
</div>
`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Custom Software FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
